import React, {Component} from 'react';
import {Row, Col, Spin} from 'antd';
import {Link} from 'react-router';

import {intToHexString, timeAgoShortFromEpochTime} from '../utils'

class PresentationBody extends Component {
  contructor(props) {
    this.handleSelection = this.handleSelection.bind(this)
  }

  handleSelection(station) {
    this.props.onRowSelection(station)
  }

  render() {
    const {stations, fetching} = this.props
    const thead = <Row align="middle" className="table-thead">
      <Col xs={{
          span: 0
        }} sm={{
          span: 0
        }} md={{
          span: 2
        }} lg={{
          span: 2
        }} xl={{
          span: 2
        }}>STT</Col>
      <Col xs={{
          span: 0
        }} sm={{
          span: 0
        }} md={{
          span: 4
        }} lg={{
          span: 4
        }} xl={{
          span: 4
        }}>Mã</Col>
      <Col xs={{
          span: 8
        }} sm={{
          span: 8
        }} md={{
          span: 6
        }} lg={{
          span: 6
        }} xl={{
          span: 6
        }}>Tên</Col>
      <Col xs={{
          span: 6
        }} sm={{
          span: 3
        }} md={{
          span: 2
        }} lg={{
          span: 2
        }} xl={{
          span: 2
        }}>
        <div className="center">Trạng thái</div>
      </Col>
      <Col xs={{
          span: 10
        }} sm={{
          span: 13
        }} md={{
          span: 8
        }} lg={{
          span: 8
        }} xl={{
          span: 8
        }}>Thông số</Col>
      <Col xs={{
          span: 0
        }} sm={{
          span: 0
        }} md={{
          span: 2
        }} lg={{
          span: 2
        }} xl={{
          span: 2
        }}>Kết nối</Col>
    </Row>
    const body = stations.length > 0
      ? stations.map((station, i) => {
        const styleRow = station.OnlineState === 0
          ? "table-row row-disconnect"
          : "table-row"
        return <Link to={`station/${station.ID}`} key={i + 1} onClick={() => this.handleSelection(station)}>
          <Row type="flex" align="middle" className={styleRow}>
            <Col xs={{
                span: 0
              }} sm={{
                span: 0
              }} md={{
                span: 2
              }} lg={{
                span: 2
              }} xl={{
                span: 2
              }}>{i + 1}</Col>
            <Col xs={{
                span: 0
              }} sm={{
                span: 0
              }} md={{
                span: 4
              }} lg={{
                span: 4
              }} xl={{
                span: 4
              }}>{intToHexString(station.HardwareID)}</Col>
            <Col xs={{
                span: 8
              }} sm={{
                span: 8
              }} md={{
                span: 6
              }} lg={{
                span: 6
              }} xl={{
                span: 6
              }}>
              <span className="ellipsis">{station.Name}</span>
            </Col>
            <Col xs={{
                span: 6
              }} sm={{
                span: 3
              }} md={{
                span: 2
              }} lg={{
                span: 2
              }} xl={{
                span: 2
              }}>
              <div className="center">{
                  station.AlarmLevel > 0
                    ? <span className="box-warning">{station.AlarmCount}</span>
                    : <span className="box-normal"></span>
                }</div>
            </Col>
            <Col xs={{
                span: 10
              }} sm={{
                span: 13
              }} md={{
                span: 8
              }} lg={{
                span: 8
              }} xl={{
                span: 8
              }}></Col>
            <Col xs={{
                span: 0
              }} sm={{
                span: 0
              }} md={{
                span: 2
              }} lg={{
                span: 2
              }} xl={{
                span: 2
              }}>
              <span className="italic">{timeAgoShortFromEpochTime(station.OnlineTime)}</span>
            </Col>
          </Row>
        </Link>
      })
      : <Row type="flex" align="middle" className="table-row" justify="center">Dữ liệu rỗng</Row>
    const content = fetching
      ? <span className="center"><Spin/></span>
      : body
    return <div className="table">
      {thead}
      <div className="table-body">
        {content}
      </div>
    </div>;
  }
}

export default PresentationBody;



// WEBPACK FOOTER //
// ./src/components/PresentationBody.js